import axios from 'axios';

export default class SelfServiceGateway {
  async getSelectedAnswer(answerId, orgId, orgDomain, lng) {
    try {
      const response = await axios.get(`${orgDomain}/api/v1/orgs/${orgId}/answers/${answerId}`, { params: { lng } });

      // TODO: probably should generate a real error but currently trying to maintain backwards compatibility
      return response.status >= 200 && response.status < 300
        ? response
        : { error: { reason: response.status, err: response.data.message } };
    } catch (error) {
      // TODO: probably should generate a real error but currently trying to maintain backwards compatibility
      return { error: { reason: 'request error', err: error.message } };
    }
  }

  async getSearchResults(searchTerm, orgId, orgDomain, lng) {
    try {
      const params = {
        lng,
        q: encodeURIComponent(searchTerm),
      };
      const url = `${orgDomain}/api/v1/orgs/${orgId}/answers/search`;
      const response = await axios.get(url, { params });

      // TODO: probably should generate a real error but currently trying to maintain backwards compatibility
      return response.status >= 200 && response.status < 300
        ? response
        : { error: { reason: response.status, err: response.data.message } };
    } catch (error) {
      // TODO: probably should generate a real error but currently trying to maintain backwards compatibility
      return { error: { reason: 'request error', err: error.message } };
    }
  }
}
